import { useState, useEffect } from "react";
import { useLiferayLanguage } from "../hooks/useLiferayLanguage";
import { initFlatpickr } from "../utils/dateUtils";
import { useLocation } from "react-router-dom";

export const Search = ({ isAirport, airportTerminals, minuteInterval, minHour, maxHour, layout }) => {

    const [terminal, setTerminal] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filter, setFilter] = useState("");

    const location = useLocation();

    useEffect(() => {
        initFlatpickr("#start-date", setStartDate, minuteInterval, minHour, maxHour, getLocale());
        initFlatpickr("#end-date", setEndDate, minuteInterval, minHour, maxHour, getLocale());
    }, []);

    useEffect(() => {
        const trigger = document.querySelector(".aena-dropdown__trigger");
        if (trigger.disabled) trigger.disabled = false;
        trigger.setAttribute("aria-controls", "aena-dropdown-panel");
        trigger.setAttribute("id", "aena-dropdown-trigger");

    }, [location])

    // useEffect(() => {
    //     console.log(terminal)
    // }, [terminal]);

    const getLocale = () => {
        const locale = Liferay.ThemeDisplay.getLanguageId();

        if (locale === 'en_US') {
            return 'en';
        } else {
            return 'es';
        }
    };

    const formatDateTimeInput = (value) => {
        const digits = value.replace(/\D/g, "");
        let formatted = "";

        if (digits.length >= 1) formatted += digits.substring(0, 2);
        if (digits.length >= 3) formatted += "-" + digits.substring(2, 4);
        if (digits.length >= 5) formatted += "-" + digits.substring(4, 8)
        if (digits.length >= 9) formatted += " " + digits.substring(8, 10);
        if (digits.length >= 11) formatted += ":" + digits.substring(10, 12);

        return formatted;
    };

    const handleStartInput = (e) => {
        const formatted = formatDateTimeInput(e.target.value);
        setStartDate(formatted);
    };

    const handleEndInput = (e) => {
        const formatted = formatDateTimeInput(e.target.value);
        setEndDate(formatted);
    };

    const selectOption = (airportTerminal, event) => {
        event.preventDefault();
        event.stopPropagation();

        const trigger = document.querySelector(".aena-dropdown__trigger.airport");
        trigger.setAttribute("aria-expanded", "false");

        const panel = document.querySelector(".aena-dropdown__panel.airport");
        panel.classList.remove("is-expanded");

        const dropdownLabel = document.querySelector(".aena-dropdown__label.airport");
        dropdownLabel.innerText = airportTerminal.label;


        setTerminal(`${airportTerminal.codigoAeropuerto}-${airportTerminal.terminalNombre}`);
    };

    /* Search Params */

    const triggerSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = document.getElementById('searchParkingForm');

        if (terminal && startDate && endDate) {

            let desde = startDate.split(" ");
            let hasta = endDate.split(" ");

            let fechaDesde = desde[0];
            let horaDesde = `${desde[1]}:00`;
            let fechaHasta = hasta[0];
            let horaHasta = `${hasta[1]}:00`;

            document.getElementById('selectedAeropuerto').value = terminal;
            document.getElementById('fechaDesde').value = fechaDesde;
            document.getElementById('horaDesde').value = horaDesde;
            document.getElementById('fechaHasta').value = fechaHasta;
            document.getElementById('horaHasta').value = horaHasta;

            form.submit();
        }
    };

    const airportTerminalsText = isAirport ?
        useLiferayLanguage("aena.parkings.terminal", "Terminal") :
        useLiferayLanguage("aena.parkings.airport.terminals", "Aeropuerto / Terminal");
    const airportTerminalsPlaceHolder = isAirport ?
        useLiferayLanguage("aena.parkings.terminal.placeholder", "Seleccionar terminal") :
        useLiferayLanguage("aena.parkings.airport.terminals.placeholder", "Selecciona aeropuerto y terminal");
    const startDateText = useLiferayLanguage("aena.parkings.start.date", "Fecha de entrada");
    const endDateText = useLiferayLanguage("aena.parkings.end.date", "Fecha de salida");
    const searchParkingText = useLiferayLanguage("aena.parkings.search.parking", "Buscar parking");

    return (
        <div className={`aena-flight-search aena-flight-search--${layout}`}>
            <form className="d-none" id="searchParkingForm" method="POST" target="_blank" action="https://parking.aena.es/reservas/web/disponibilidad.ac">
                <input type="hidden" name="selectedAeropuerto" id="selectedAeropuerto" />
                <input type="hidden" name="fechaDesde" id="fechaDesde" />
                <input type="hidden" name="horaDesde" id="horaDesde" />
                <input type="hidden" name="fechaHasta" id="fechaHasta" />
                <input type="hidden" name="horaHasta" id="horaHasta" />
            </form>

            <div className="aena-fields aena-fields--align-end">
                <div className="aena-field">
                    <label className="paragraph-semibold-medium" for="aena-dropdown-trigger">{airportTerminalsText}</label>
                    <div className="aena-dropdown aena-dropdown--w-full">
                        <button
                            aria-controls="aena-dropdown-panel"
                            aria-expanded="false"
                            aria-haspopup="listbox"
                            className="aena-dropdown__trigger airport aena-input aena-input--large"
                            id="aena-dropdown-trigger"
                            role="combobox"
                            tabindex="0"
                            type="button"
                        >
                            <svg className="aena-sprite" aria-hidden="true" focusable="false">
                                <use href="/o/aena-theme-spritemap/spritemap.svg#aviones-y-aeropuertos-torre-de-control"></use>
                            </svg>
                            <span className="aena-dropdown__label airport">{airportTerminalsPlaceHolder}</span>
                            <svg className="aena-sprite aena-dropdown__toggle" aria-hidden="true" focusable="false">
                                <use href="/o/aena-theme-spritemap/spritemap.svg#digital-flecha-abajo-1"></use>
                            </svg>
                        </button>

                        <ul
                            aria-labelledby="aena-dropdown-trigger"
                            className="aena-dropdown__panel airport"
                            id="aena-dropdown-panel"
                            role="listbox"
                            tabindex="-1"
                        >
                            {!isAirport && (
                                <li>
                                    <input
                                        type="text"
                                        className="aena-input aena-input--small aena-dropdown__filter"
                                        placeholder="Buscar aeropuerto o terminal"
                                        value={filter}
                                        onChange={(e) => setFilter(e.target.value)}
                                    />
                                </li>
                            )}
                            {(!isAirport && filter.length >= 3
                                ? airportTerminals.filter(at =>
                                    at.label.toLowerCase().includes(filter.toLowerCase())
                                )
                                : airportTerminals
                            ).map((airportTerminal) => (
                                <li
                                    aria-selected={terminal == airportTerminal.label}
                                    className="aena-dropdown__option terminal aena-dropdown__option--large"
                                    key={airportTerminal.label}
                                    onClick={(e) => selectOption(airportTerminal, e)}
                                    role="option"
                                >
                                    {airportTerminal.label}
                                </li>

                            ))}
                        </ul>
                    </div>
                </div>

                <div className="aena-field">
                    <label className="paragraph-semibold-medium" for="start-date">{startDateText}</label>
                    <div className="aena-input-wrapper">
                        <svg className="aena-sprite aena-input-sprite" aria-hidden="true" focusable="false">
                            <use href="/o/aena-theme-spritemap/spritemap.svg#documentos-calendario-2"></use>
                        </svg>
                        <input
                            type="text"
                            id="start-date"
                            className="aena-input start aena-input--decorated aena-input--large"
                            placeholder="Fecha y hora de entrada"
                            value={startDate}
                            onChange={(e) => handleStartInput(e)}
                        />
                    </div>
                </div>

                <div className="aena-field">
                    <label className="paragraph-semibold-medium" for="end-date">{endDateText}</label>
                    <div className="aena-input-wrapper">
                        <svg className="aena-sprite aena-input-sprite" aria-hidden="true" focusable="false">
                            <use href="/o/aena-theme-spritemap/spritemap.svg#documentos-calendario-2"></use>
                        </svg>
                        <input
                            type="text"
                            id="end-date"
                            className="aena-input end aena-input--decorated aena-input--large"
                            placeholder="Fecha y hora de salida"
                            value={endDate}
                            onChange={(e) => handleEndInput(e)}
                        />
                    </div>
                </div>
            </div>

            <button className="aena-flight-search__submit aena-button aena-button--primary aena-button--large" onClick={(e) => triggerSearch(e)}>
                {searchParkingText}
                <svg className="aena-sprite" aria-hidden="true" focusable="false">
                    <use href="/o/aena-theme-spritemap/spritemap.svg#coches-parking-coche"></use>
                </svg>
            </button>
        </div>
    );
};